import { render } from "./businessSummary.vue?vue&type=template&id=0f57ee92&scoped=true&ts=true"
import script from "./businessSummary.vue?vue&type=script&lang=ts"
export * from "./businessSummary.vue?vue&type=script&lang=ts"

import "./businessSummary.vue?vue&type=style&index=0&id=0f57ee92&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f57ee92"]])

export default __exports__